import { ServiceMaker, methods, services } from "@/services";

export const createConcern = payload =>
  ServiceMaker(
    `/communication/concern`,
    methods.POST,
    services.master,
    payload
  );

export const deleteConcern = Id =>
  ServiceMaker(
    `/communication/concern/${Id}`,
    methods.DELETE,
    services.master
  );

export const concernListFilter = payload =>
  ServiceMaker(
    `/communication/concern?name=${payload.name}&type=${payload.type}`,
    methods.GET,
    services.master
  );